module.exports = __webpack_public_path__ + "img/crescent.57e14af8.png";